<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" v-if="informText != ''">
          <v-alert type="error">{{ informText }}</v-alert>
        </v-col>

        <v-col cols="6">
          <v-autocomplete
            :items="storeResponse"
            label="Select Store"
            :item-text="(obj) => obj.code"
            :item-value="(obj) => obj"
            v-model="storeSelected"
            dense
            outlined
            hide-details
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="6" style="text-align: right">
          <router-link
            to="cross-sale-create"
            v-if="roles.create_cross_sale_products"
          >
            <v-btn color="success">CREATE</v-btn>
          </router-link>
        </v-col>

        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="showData"
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  class="shrink mx-4"
                ></v-text-field>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:item.title="{ item }">
              <template v-if="item.type == 'Product to products'">
                <div>
                  {{ item.title }}
                  <a
                    target="_blank"
                    :href="storeSelected.domain + '/products/' + item.handle"
                    ><v-icon>mdi-eye</v-icon></a
                  >
                  <div><b>Product ID: </b>{{ item.id }}</div>
                  <img :src="item.preview" width="150px" />
                </div>
              </template>
              <template v-else
                >{{ item.title }}
                <a
                  target="_blank"
                  :href="storeSelected.domain + '/collections/' + item.handle"
                  ><v-icon>mdi-eye</v-icon></a
                >
                <div><b>Product Count:</b> {{ item.products_count }}</div>
              </template>
            </template>

            <template v-slot:item.type="{ item }">
              <b>{{ item.type }}</b>
            </template>

            <template v-slot:item.id="{ item }">
              <template
                v-for="(a, indexa) of item.crossSellProducts"
                style="margin-right: 5px"
              >
                <span class="container" :key="item.id + '-' + indexa"
                  ><a
                    :href="storeSelected.domain + '/products/' + a.handle"
                    target="_blank"
                  >
                  </a>

                  <img :src="a.image" :title="a.title" width="150px" />
                  <v-btn
                    v-if="roles.delete_cross_sale_products"
                    class="btn-inside"
                    x-small
                    color="orange"
                    dark
                    @click="deleteProdCrossSell(a)"
                    ><v-icon small>mdi-delete</v-icon></v-btn
                  >
                </span>
              </template>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CrossSellList",

  data: () => ({
    storeResponse: [],
    crossSellData: [],
    roles: [],

    headers: [
      { text: "Title", value: "title", width: "25%", sortable: false },
      { text: "Mapping Type", value: "type", sortable: false },
      {
        text: "Products Cross Sell",
        value: "id",
        sortable: false,
      },
    ],

    storeSelected: null,
    search: null,
    showData: [],
    loading: false,

    informText: "",
  }),

  watch: {
    async storeSelected() {
      console.log("store: ", this.storeSelected);
      this.loading = true;
      await this.loadCollection();
      await this.loadData();
      this.loading = false;
    },
  },

  methods: {
    async loadStore() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "site-load"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "sites?platform=Shopify", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log(response);
            // If request is good...
            this.storeResponse = response.data.data;
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log("currentSession site-loadData-undefined: ", currentSession);
      }
    },

    async loadCollection() {
      this.informText = "";
      this.loading = true;
      await axios
        .get(this.storeSelected.domain + "/collections.json?limit=250&page=1")
        .then((response) => {
          console.log("response: ", response);
          this.listCollections = response.data.collections;
        })
        .catch((err) => {
          console.log("Err: ", err);
          this.informText = err;
          this.loading = false;
        });

      var temp = [];

      await axios
        .get(this.storeSelected.domain + "/collections.json?limit=250&page=2")
        .then((response) => {
          console.log("response: ", response);
          temp = response.data.collections;
          if (response.data.collections.length > 0)
            this.listCollections += response.data.collections;
        })
        .catch((err) => {
          console.log("Err: ", err);
          this.informText = err;
          this.loading = false;
        });

      if (temp.length > 0) {
        await axios
          .get(this.storeSelected.domain + "/collections.json?limit=250&page=3")
          .then((response) => {
            console.log("response: ", response);
            temp = response.data.collections;
            if (response.data.collections.length > 0)
              this.listCollections += response.data.collections;
          })
          .catch((err) => {
            console.log("Err: ", err);
            this.informText = err;
            this.loading = false;
          });
      }
      if (temp.length > 0) {
        await axios
          .get(this.storeSelected.domain + "/collections.json?limit=250&page=4")
          .then((response) => {
            console.log("response: ", response);
            temp = response.data.collections;
            if (response.data.collections.length > 0)
              this.listCollections += response.data.collections;
          })
          .catch((err) => {
            console.log("Err: ", err);
            this.informText = err;
            this.loading = false;
          });
      }
      if (temp.length > 0) {
        await axios
          .get(this.storeSelected.domain + "/collections.json?limit=250&page=5")
          .then((response) => {
            console.log("response: ", response);
            temp = response.data.collections;
            if (response.data.collections.length > 0)
              this.listCollections += response.data.collections;
          })
          .catch((err) => {
            console.log("Err: ", err);
            this.informText = err;
            this.loading = false;
          });
      }
      this.loading = false;
    },

    async loadData() {
      this.showData = [];
      this.informText = "";
      var currentSession = await this.$root.$refs.App.currentSession(
        "crossSellList-load"
      );
      //console.log('currentSession: ',currentSession.accessToken)

      var param = {
        store_admin_domain: this.storeSelected.shopify_admin_domain,
      };

      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "cross-sale-products", {
            headers: { Authorization: currentSession.accessToken },
            params: param,
          })
          .then((response) => {
            console.log("response: ", response);
            // If request is good...
            if (response.data.error_message == "") {
              var dataResponse = response.data.data;
              //Loc theo product to product
              var prodToProd = dataResponse.filter(
                (p) => p.mapping_type == "product_to_products"
              );

              var tempProdList = new Set();

              if (prodToProd.length > 0) {
                prodToProd.map((t) =>
                  tempProdList.add(
                    t.collection_id +
                      " | " +
                      t.source_product_title +
                      " | " +
                      t.source_product_handle +
                      " | " +
                      t.source_product_image
                  )
                );

                var listProduct = Array.from(tempProdList);
                var temp = [];

                listProduct.map((b) => {
                  var productCross = {
                    id: b.split(" | ")[0],
                    title: b.split(" | ")[1],
                    products_count: null,
                    handle: b.split(" | ")[2],
                    preview: b.split(" | ")[3],
                    type: "Product to products",
                  };

                  var filter = prodToProd.filter(
                    (c) => c.collection_id == b.split(" | ")[0]
                  );
                  productCross["crossSellProducts"] = JSON.parse(
                    JSON.stringify(filter)
                  );

                  temp.push(productCross);
                });

                console.log("temp: ", temp);
              }

              //Loc theo collection to product
              for (var a of this.listCollections) {
                var filter = dataResponse.filter(
                  (b) => b.collection_id == a.id
                );
                a["crossSellProducts"] = JSON.parse(JSON.stringify(filter));
                a["type"] = "Collection to products";
              }

              this.showData = this.listCollections.filter(
                (b) => b.crossSellProducts.length > 0
              );

              if (temp) this.showData = this.showData.concat(temp);

              if (!this.showData) {
                this.showData = [];
              }
              console.log("showData: ", this.showData);
            } else {
              this.informText = response.data.error_message;
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession crossSellList-load-undefined: ",
          currentSession
        );
      }
    },

    async deleteProdCrossSell(item) {
      var r = confirm("Are you sure to delete this product?");
      if (r) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "crossSellList-delete"
        );
        //console.log('currentSession: ',currentSession.accessToken)

        var param = {
          collection_id: item.collection_id,
          product_id: item.product_id,
        };

        var admin_domain = this.storeSelected.shopify_admin_domain.replace(
          "https://",
          ""
        );

        if (currentSession.accessToken) {
          await axios
            .delete(window.domain + "cross-sale-products/" + admin_domain, {
              headers: { Authorization: currentSession.accessToken },
              params: param,
            })
            .then((response) => {
              console.log("response: ", response);
              //var dataResponse = response.data.data;
              if (response.data.error_message != "") {
                this.informText = response.data.error_message;
              } else {
                for (var a of this.showData) {
                  if (a.id == item.collection_id) {
                    a.crossSellProducts = a.crossSellProducts.filter(
                      (b) => b != item
                    );
                  }
                }
              }
            });
        }
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("cross_sale_product");

    if (this.roles.list_cross_sale_products) {
      await this.loadStore();
    } else {
      this.$router.push("/not-authorized");
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
}

.container .btn-inside {
  position: absolute;
  right: 0;
}
</style>